import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Spinner } from "react-bootstrap";
import API from "../api";
import { useAuth } from "../context/AuthContext";

export default function PlayerManager() {
  const { user } = useAuth();
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingPlayer, setEditingPlayer] = useState(null);

  const emptyPlayer = {
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    paiddues: "",
    isSub: 0,
    active: true,
  };

  const fetchPlayers = async () => {
    try {
      const res = await API.get(`/players`);
      setPlayers(res.data);
    } catch (err) {
      console.error("Failed to load players:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user?.leagueid) fetchPlayers();
  }, [user?.leagueid]);

  const handleSave = async () => {
    try {
      if (editingPlayer.id) {
        await API.put(`/players/${editingPlayer.id}`, {
          ...editingPlayer,
        });
      } else {
        await API.post(`/players`, {
          ...editingPlayer,
          leagueid: user.leagueid,
        });
      }

      setShowModal(false);
      setEditingPlayer(null);
      fetchPlayers();
    } catch (err) {
      alert("Error saving player.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this player?")) return;
    try {
      await API.delete(`/players/${id}`);
      fetchPlayers();
    } catch (err) {
      alert("Error deleting player.");
    }
  };

  if (loading) return <Spinner animation="border" className="m-5" />;

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Manage Players</h4>
        <Button size="sm" onClick={() => {
          setEditingPlayer({ ...emptyPlayer });
          setShowModal(true);
        }}>
          Add Player
        </Button>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Dues</th>
            <th>Sub?</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {players.map((p) => (
            <tr key={p.id}>
              <td>{p.firstname} {p.lastname}</td>
              <td>{p.phone}</td>
              <td>{p.email}</td>
              <td>${parseFloat(p.paiddues || 0).toFixed(2)}</td>
              <td>{p.isSub ? "Yes" : "No"}</td>
              <td>{p.active ? "Yes" : "No"}</td>
              <td>
                <Button
                  size="sm"
                  variant="outline-primary"
                  onClick={() => {
                    setEditingPlayer({ ...p });
                    setShowModal(true);
                  }}
                >
                  Edit
                </Button>{" "}
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={() => handleDelete(p.id)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editingPlayer?.id ? "Edit Player" : "Add Player"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editingPlayer && (
            <Form>
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  value={editingPlayer.firstname}
                  onChange={(e) => setEditingPlayer({ ...editingPlayer, firstname: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  value={editingPlayer.lastname}
                  onChange={(e) => setEditingPlayer({ ...editingPlayer, lastname: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  value={editingPlayer.phone}
                  onChange={(e) => setEditingPlayer({ ...editingPlayer, phone: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  value={editingPlayer.email}
                  onChange={(e) => setEditingPlayer({ ...editingPlayer, email: e.target.value })}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Dues Paid</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  value={editingPlayer.paiddues}
                  onChange={(e) => setEditingPlayer({ ...editingPlayer, paiddues: e.target.value })}
                />
              </Form.Group>
              <Form.Check
                type="checkbox"
                label="Substitute"
                checked={!!editingPlayer.isSub}
                onChange={(e) => setEditingPlayer({ ...editingPlayer, isSub: e.target.checked ? 1 : 0 })}
              />
              <Form.Check
                type="checkbox"
                label="Active"
                checked={!!editingPlayer.active}
                onChange={(e) => setEditingPlayer({ ...editingPlayer, active: e.target.checked })}
              />
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
